import React, { Component } from 'react';
import {Link, withRouter} from 'react-router-dom';
import 'url-search-params-polyfill';

import { RESPONSE_STATUS } from '../../../utils/constants';

let enabled = {
    border: 0,
    background: '#ffad94',
    textDecoration:'none',
    color: '#ffffff'
};

class AthReset extends Component {
    constructor(props){
        super(props);
        this.state = {
            email: '',
            password: '',
            resetTriggered: false,
            resetKey: null,
            isCreatingPassword: false,
            errorMessage: ''
        };
    }

    componentWillMount() {
        const params = new URLSearchParams(this.props.location.search);
        const resetKey = params.get('key');
        if (resetKey) {
            this.setState({ resetKey: resetKey, isCreatingPassword: this.props.location.pathname === "/create-password" });
        }
    }

    handleChange(e) {
        if (e.target.name === 'email') {
            this.setState({ email: e.target.value });
        }
        if (e.target.name === 'password') {
            this.setState({ password: e.target.value });
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        const { email, password, resetKey } = this.state;
        if (resetKey) {
            if (password) {
                fetch('/api/ath/reset_password/finish', {
        			method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
        			body: JSON.stringify({
                        key: resetKey,
                        newPassword: password
                    })
        		}).then(response => {
        			if (response.status === RESPONSE_STATUS.OK) {
                        return response.json();
        			} else {
                        alert("There is a problem with the new password. Please try again.");
                    }
        		}).then(json => {
                    if (json) {
                        localStorage.setItem('auth_token', json.token.token);
                        localStorage.setItem('user_id', json.userId);
                        localStorage.setItem('user_firstname', json.firstName);
                    }
                    this.props.history.push('/survey-result');
                });
            }
        } else {
            if (email) {
                fetch('/api/ath/reset_password/init', {
        			method: 'POST',
        			body: email
        		}).then(response => {
        			if (response.status === RESPONSE_STATUS.OK) {
                        this.setState({ resetTriggered: true, errorMessage: '' });
        			} else {
                        response.text().then(message => {
                            this.setState({ resetTriggered: false, errorMessage: message });
                        })
                    }
        		});
            }
        }
    }

    renderEmailErrorMessage() {
        const hideErrorMessage = this.state.errorMessage ? "" : "hide-me-transparent";
        return <div className={ "error-message " + hideErrorMessage }>{ this.state.errorMessage }</div>;
    }

    renderTitle() {
        if (this.state.resetTriggered) {
            return (
                <div className="title">
                    <div>An email has been sent to your email.</div>
                    <div>Click the link in the email to reset</div>
                    <div>your password.</div>
                </div>
            );
        }
        if (this.state.isCreatingPassword) {
            return (
                <div className="title">
                    <div>Let's create your password</div>
                </div>
            );
        }
        return (
            <div className="title">
                <div>Don't worry,</div>
                <div>let's reset your password</div>
            </div>
        );
    }

    renderInput() {
        if (this.state.resetKey) {
            return (
                <div className="form-input-row">
                    <input type="password" ref="password" name="password" placeholder='Password'
                        value={this.state.password} onChange={ this.handleChange.bind(this) }/>
                </div>
            );
        } else {
            return (
                <div className="form-input-row">
                    <input type="text" ref="email" name="email" placeholder='Email'
                        value={this.state.email} onChange={ this.handleChange.bind(this) }/>
                </div>
            );
        }
    }

    renderActionButton() {
        if (this.state.resetTriggered) {
            return (
                <button style={ enabled }>Got it</button>
            );
        }
        if (this.state.resetKey) {
            const action = this.state.isCreatingPassword ? 'Create' : 'Reset';
            return (
                <button style={ this.state.password ? enabled : null } disabled={ !this.state.password }
                    onClick={ this.handleSubmit.bind(this) }>{ action + ' Password' }</button>
            );
        } else {
            return (
                <button style={ this.state.email ? enabled : null } disabled={ !this.state.email }
                    onClick={ this.handleSubmit.bind(this) }>Reset Password</button>
            );
        }
    }

    render() {
        return (
            <div className="reset-password">
                <div className="form">
                    { this.renderTitle() }
                    { this.renderInput() }
                    { this.renderEmailErrorMessage() }
                    <div className="form-action-row">
                        { this.renderActionButton() }
                        <div className="link-wrapper">
                            <Link style={{ textDecoration:'none' }} to="/ath/login">Back to log in</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(AthReset);



// WEBPACK FOOTER //
// ./src/ath/views/reset/AthReset.js